module.exports = __webpack_public_path__ + "img/help3-1-6.9c40b6e8.png";